import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from 'app/types-store';
import { OptionsDispatchProps, OptionsState } from './types';
import { actionCreatorsFactory } from './actions';
import get from 'lodash/get';
import { AppDispatch } from 'app/infrastructure/configure-store';

const createStateToProps = (path: string) =>
  (state: ApplicationState): OptionsState => ({
    options: get(state, path)?.options || {}
  });

const createMapDispatchToProps = (path: string) => (dispatch: AppDispatch) => ({
  dispatch,
  ...bindActionCreators(actionCreatorsFactory(path), dispatch)
});

export const withOptions = <T>
(component: React.ComponentType<React.PropsWithChildren<T & OptionsState & OptionsDispatchProps>> & { statePath: string }) => {
  return connect(
    createStateToProps(component.statePath),
    createMapDispatchToProps(component.statePath)
  )(component as any); // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
};
